import React from "react";
import RemotePodLoader from "../components/recording/RemotePodLoader";

const loadRecordingPulseScan = () => import("recordingPulseScan/App");

export default function RecordingPulseScanRouter(props) {
  return (
    <RemotePodLoader
      load={loadRecordingPulseScan}
      componentProps={{
        ...props,
        onUploadProgress: props.onUploadProgress,
      }}
    />
  );
}
